import React from "react";
import { NumericFormat } from "react-number-format";

function NumberFormatCustom(props: any) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      allowNegative={false}
      decimalScale={0}
      valueIsNumericString
      suffix=" inches"
    />
  );
}

export default NumberFormatCustom;
